// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperPreviewList-cls1_KlR","cls2":"PaperPreviewList-cls2_BfX PaperPreviewList-cls1_KlR"};